<template>
  <div>
    <b-container>
      <h1 v-if="!staticItem && id">
        <span v-translate="{type: $appConfig.models[this.type].title}">Edit %{type}</span>
        <b-button v-if="item.status === 'finished'" size="sm" @click="openModalAccountingNote" v-translate>Accounting Note</b-button>
      </h1>
      <h1 v-else-if="!staticItem && !id" v-translate="{type: $appConfig.models[this.type].title}">New %{type}</h1>
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="success"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged"
      >
        <translate>The Item has been updated</translate>
      </b-alert>
    </b-container>
    <b-container v-if="this.type" fluid>
      <fleet-rental-order-form :fleet-rental-order="item" @success="showAlert" />
      <div class="simplert d-block" v-if="isLoading">
        <spinner v-if="isLoading" />
      </div>
    </b-container>
  </div>
</template>
<script>
import FleetRentalOrderForm from '@/components/FleetRentalOrderForm'
import Spinner from '@/components/Spinner'

export default {
  name: 'FleetRentalOrderEdit',
  components: {
    FleetRentalOrderForm,
    Spinner
  },
  props: {
    type: {
      type: String,
      default: 'fleet-rental-orders'
    },
    id: {
      type: [Number, String],
      required: false
    },
    staticItem: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      initialized: false,
      fields: this.$appConfig.models[this.type].fields,
      item: undefined,
      success: false,
      isLoading: false,
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  mounted() {
    if (!this.staticItem && this.id) {
      this.getItem()
    } else if (this.staticItem) {
      this.item = this.staticItem.item
    }
    this.init()
  },
  methods: {
    async init() {
      this.initialized = true
    },
    getItem() {
      this.isLoading = true
      let params = {}
      if (this.$appConfig.models[this.type].includes) {
        params.includes = this.$appConfig.models[this.type].includes
      }
      this.$http.get(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint + '/' + this.id, {params: params})
        .then(response => {
          if (!response.body.fleet_rental_order_vehicles) {
            response.body.fleet_rental_order_vehicles = []
          }
          this.item = response.body
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    openModalAccountingNote() {
      this.$root.$emit('bv::show::modal', 'modalMenuAccountingNote')
      this.$root.$once('bv::modal::shown', (e) => {
        if (e.componentId === 'modalMenuAccountingNote') {
          setTimeout(() => {
            this.$root.$children[0].$refs.accountingNoteForm.accountSearchType = 'company'
            setTimeout(() => {
              this.$root.$children[0].$refs.accountingNoteForm.accountOwner = this.item.company.name
              this.$root.$children[0].$refs.accountingNoteForm.accountingNote = {
                account_id: this.item.company.account.id,
                type: 'credit',
                amount: null,
                currency: this.item.company.country.currency,
                shipping_id: null,
                service_id: null,
                fleet_rental_order_id: this.item.id,
                relationship: 'client',
                reference: '',
                visibility: 'all',
                imputation_date: null,
                status: 'pending'
              }
            }, 100)
          }, 500)
        }
      })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>
